import { AnalyticsEvent } from '@att-bit/ui-frameworks.components.analytics-event';
import { docComplete } from '../utils/UtilityFunctions';
/**
 * Any reporting call should fire through this Class further.
 */
var ReportingGateway = /** @class */ (function () {
    function ReportingGateway() {
    }
    /**
     * This filter method make sure that if eventAction is SystemEvent
     * It should not report the following parameters at all
     * linkName
     * linkDestinationUrl
     * linkPosition
     * @param appAnalyticsEvent
     */
    ReportingGateway.filterLinkAttributesForSystemEvent = function (appAnalyticsEvent) {
        if (appAnalyticsEvent.eventAction && appAnalyticsEvent.eventAction === 'systemEvent') {
            if (appAnalyticsEvent && appAnalyticsEvent.additionalData) {
                // tslint:disable-next-line:no-any
                var data = appAnalyticsEvent.additionalData;
                if (appAnalyticsEvent.additionalData.hasOwnProperty('linkName')) {
                    delete data.linkName;
                }
                if (data.hasOwnProperty('linkDestinationUrl')) {
                    delete data.linkDestinationUrl;
                }
                if (data.hasOwnProperty('linkPosition')) {
                    delete data.linkPosition;
                }
            }
        }
    };
    ReportingGateway.filterAttributesForFormSubmitEvent = function (appAnalyticsEvent) {
        if (appAnalyticsEvent.eventAction && appAnalyticsEvent.eventAction === 'formSubmit') {
            if (appAnalyticsEvent && appAnalyticsEvent.additionalData) {
                // tslint:disable-next-line:no-any
                var data = appAnalyticsEvent.additionalData;
                if (data.hasOwnProperty('successFlag')) {
                    data.successFlag = '-2';
                }
                if (appAnalyticsEvent.additionalData.hasOwnProperty('statusMessage')) {
                    delete data.statusMessage;
                }
            }
        }
    };
    ReportingGateway.sendReportingEvent = function (analyticsEvent) {
        console.log('Reporting event data', analyticsEvent);
        try {
            docComplete(function () {
                ReportingGateway.filterLinkAttributesForSystemEvent(analyticsEvent);
                ReportingGateway.filterAttributesForFormSubmitEvent(analyticsEvent);
                AnalyticsEvent(analyticsEvent);
            });
        }
        catch (e) {
            console.log('test new analytics page', e);
        }
    };
    return ReportingGateway;
}());
export default ReportingGateway;
//# sourceMappingURL=ReportingGateway.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/ReportingGateway.js
// module id = 154
// module chunks = 8